import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { FSWalletAccountRepository } from '../../../core/repository/fs-wallet-account.repository';
import { BindingCallbackDTO } from '../../../core/usecase/fs-wallet-account/interface/binding-callback.dto';
import { OtpRequestDTO } from '../../../core/usecase/fs-wallet-account/interface/otp-request.dto';
import { OtpValidateDTO } from '../../../core/usecase/fs-wallet-account/interface/otp-validate.dto';
import { PinCallbackDTO } from '../../../core/usecase/fs-wallet-account/interface/pin-callback.dto';
import {
  HttpWalletAccountBindingCallbackCollectionResponse,
  HttpWalletAccountBindingCollectionResponse,
  HttpWalletAccountPinCallbackCollectionResponse,
  HttpWalletAccountRequestOtpCollectionResponse,
  HttpWalletAccountValidateOtpCollectionResponse,
} from './http-fs-wallet-account.collection';

@Injectable({ providedIn: 'root' })
export class HttpFSWalletAccountRepository implements FSWalletAccountRepository {
  private readonly fs_wallet_account_api_url: string =
    environment.credit_card_api_url + '/api/v1/wallets';
  private readonly fs_wallet_account_int_api_url: string =
    environment.paper_mars_api_url + '/internal/wallets';

  constructor(private readonly http: HttpClient) {}

  RequestWalletOtp(
    data: OtpRequestDTO
  ): Observable<HttpWalletAccountRequestOtpCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/request-otp';

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
    });

    return this.http.post<any>(load_url, {}, { headers: headers });
  }

  ValidateWalletOtp(
    data: OtpValidateDTO
  ): Observable<HttpWalletAccountValidateOtpCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/verify-otp';
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
    });

    const payload = data.payload;

    return this.http.post<any>(load_url, payload, { headers: headers });
  }

  WalletPinCallback(
    data: PinCallbackDTO
  ): Observable<HttpWalletAccountPinCallbackCollectionResponse> {
    const load_url = environment.paper_mars_api_url + '/wallets/' + data.wallet_id + '/pin-callback'
    // `accountId=${data.accountId}&partnerReferenceNo=${data.partnerReferenceNo}&status=${data.status}`;

    const headers = new HttpHeaders({
      'company_id': 'xxx',
      'user_id': 'xxx',
      'Authorization': 'Basic cGFwZXJpZDpwNHAzcjFuZDBuM3MxNA=='
    });

    const payload = {
      accountId: data.accountId,
      partnerReferenceNo: data.partnerReferenceNo,
      status: data.status,
    }
    

    return this.http.post<any>(load_url, payload, { headers: headers });
  }

  WalletBinding(
    wallet_id: string
  ): Observable<HttpWalletAccountBindingCollectionResponse> {
    const load_url = environment.paper_mars_api_url + '/wallets/' + wallet_id + '/binding';

    const headers = new HttpHeaders({
      'company_id': 'xxx',
      'user_id': 'xxx',
      'Authorization': 'Basic cGFwZXJpZDpwNHAzcjFuZDBuM3MxNA=='
    });

    return this.http.post<any>(load_url, {}, { headers: headers });
  }

  WalletBindingCallback(
    data: BindingCallbackDTO
  ): Observable<HttpWalletAccountBindingCallbackCollectionResponse> {
    const load_url = environment.paper_mars_api_url + '/wallets/' + data.wallet_id + '/binding-callback'

    const headers = new HttpHeaders({
      'company_id': 'xxx',
      'user_id': 'xxx',
      'Authorization': 'Basic cGFwZXJpZDpwNHAzcjFuZDBuM3MxNA=='
    });

    const payload = {
      auth_code: data.authCode,
      partner_reference_no: data.partnerReferenceNo,
      status: data.status,
    }

    return this.http.post<any>(load_url, payload, { headers: headers });
  }
}
